/**
 * Author Telent
 * Date 2024-11-11
 * Version 1.0
 */

/* eslint-disable */

const YOUMENG_ID = '1280066426';
const YOUMENG_JS_ID = '203467608';
const YOUMENG_LOG_ID = '6758097f8f232a05f1cf7951';
const YOUMENG_DOMAIN_LIST: string[] = ['wxapp.gz-cmc.com'];

class YouMeng {
  static #isInit = false;
  /**
   * 引入 script 脚本
   * @param url
   * @param name
   * @param loadCb
   * @param errofCb
   * @returns
   */
  static #loadScript(
    url: string,
    id: string,
    loadCb?: Function,
    errofCb?: Function,
  ) {
    const existScript = document.querySelector(`script[id=${id}]`);
    if (existScript) {
      if (loadCb) {
        loadCb();
      }
      return;
    }
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.setAttribute('id', id);
    script.onerror = (err) => {
      if (errofCb) {
        errofCb(err);
      }
    };
    script.onload = () => {
      if (loadCb) {
        loadCb();
      }
    };
    script.src = url;
    document.getElementsByTagName('html')[0].append(script);
  }

  /**
   * 根据userAgent判断当前环境
   * @returns
   */
  static #browerVersion() {
    const { userAgent } = navigator;
    const userIdMatchs = userAgent.match(/userId\/(.*?) /);
    const weixinVersion = userAgent.match(/MicroMessenger\/([\d.]+)/i);
    return {
      trident: userAgent.indexOf('Trident') > -1, // IE内核
      presto: userAgent.indexOf('Presto') > -1, // opera内核
      webKit: userAgent.indexOf('AppleWebKit') > -1, // 苹果、谷歌内核
      gecko:
        userAgent.indexOf('Gecko') > -1 && userAgent.indexOf('KHTML') === -1, // 火狐内核
      mobile: !!userAgent.match(/AppleWebKit.*Mobile.*/), // 是否为移动终端
      ios: !!userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), // ios终端
      android:
        userAgent.indexOf('Android') > -1 || userAgent.indexOf('Adr') > -1, // android终端
      iPhone: userAgent.indexOf('iPhone') > -1, // 是否为iPhone或者QQHD浏览器
      iPad: userAgent.indexOf('iPad') > -1, // 是否iPad
      webApp: userAgent.indexOf('Safari') === -1, // 是否web应该程序，没有头部与底部
      weixin: userAgent.indexOf('MicroMessenger') > -1, // 是否微信
      myApp: userAgent.indexOf('pdmiryun') > -1, // 在app里面打开
      rmcb: userAgent.indexOf('rmcb') > -1, // 在融媒采编app里面打开
      userId: userIdMatchs?.length ? userIdMatchs[1].replace(/ /g, '') : '',
      iframe: window.self !== window.top,
      windowWeixin: userAgent.indexOf('WindowsWechat') > -1,
      macWeixin: userAgent.indexOf('MacWechat') > -1,
      wxVersion: weixinVersion && weixinVersion.length ? weixinVersion[1] : 0,
      wxWork: userAgent.indexOf('WxWork') > -1,
      miniProgram: userAgent.indexOf('miniProgram') > -1,
      harmonyOS:
        userAgent.includes('OpenHarmony') || userAgent.includes('ArkWeb'),
    };
  }

  /**
   * 设置 Cookie
   * @param name - Cookie 名称
   * @param value - Cookie 值
   * @param days - Cookie 过期天数
   */
  static #setCookie(name: string, value: string, days: number) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    const expires = 'expires=' + date.toUTCString();
    document.cookie = name + '=' + value + ';' + expires + ';path=/';
  }

  /**
   * 获取 Cookie
   * @param name - Cookie 名称
   * @returns Cookie 值或 undefined
   */
  static #getCookie(name: string): string | undefined {
    const nameEQ = name + '=';
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return undefined;
  }

  static #uuid() {
    const s: string[] = [];
    const hexDigits = '0123456789abcdef';
    for (let i = 0; i < 32; i += 1) {
      s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
    }
    s[14] = '4';
    s[19] = hexDigits.substr((s[19] && 0x3) || 0x8, 1);
    return s.join('');
  }

  /**
   * 获取浏览器cookie id
   * @param fn
   */
  static #getBrowerAppId(fn: (appid: string) => void) {
    const cacheAppId = this.#getCookie('fingerprint');
    if (cacheAppId) {
      fn(cacheAppId);
    } else {
      const visitorId = this.#uuid();
      this.#setCookie('fingerprint', visitorId, 365);
      fn(visitorId);
    }
  }

  static initYoumengLog(callback?: Function) {
    if (!YOUMENG_DOMAIN_LIST.includes(window.location.host)) return;
    window.aplus_queue = window.aplus_queue || [];
    const src = `https://d.alicdn.com/alilog/mlog/aplus/${YOUMENG_JS_ID}.js`;
    if (this.#isInit) {
      if (callback) {
        callback();
      }
      return;
    }
    YouMeng.#loadScript(src, 'beacon-aplus', () => {
      this.#isInit = true;
      this.#getBrowerAppId((browerId) => {
        window.aplus_queue.push({
          action: 'aplus.setMetaInfo',
          arguments: ['appKey', YOUMENG_LOG_ID],
        });
        const version = this.#browerVersion();
        const channel = Object.entries(version)
          .filter(([key, value]) => !!value && key !== 'userId')
          .map(([key]) => key)
          .join(',');
        window.onbeforeunload = () => {
          window.aplus_queue.push({
            action: 'aplus.record',
            arguments: [
              'gzcmc.xhc.h5.shutdown',
              'shutdown',
              {
                cookie_id: browerId,
                c_time: `${new Date().getTime()}t`,
                user_id: version.userId,
                channel_code: channel,
              },
            ],
          });
        };
        if (callback) {
          callback();
        }
      });
    });
  }

  /**
   * 推送日志
   * @param eventParams
   * @param eventCode
   * @param eventType
   */
  static #startPush(
    eventParams: Record<string, string>,
    eventCode: string,
    eventType: string,
  ) {
    this.#getBrowerAppId((browerId) => {
      const version = this.#browerVersion();
      const channel = Object.entries(version)
        .filter(([key, value]) => !!value && key !== 'userId')
        .map(([key]) => key)
        .join(',');
      window.aplus_queue.push({
        action: 'aplus.record',
        arguments: [
          eventCode,
          eventType,
          {
            cookie_id: browerId,
            c_time: `${new Date().getTime()}t`,
            user_id: version.userId,
            channel_code: channel,
            ...eventParams,
          },
        ],
      });
    });
  }

  /**
   * 上传数据
   * @param eventParams
   * @param eventCode
   * @param eventType
   */
  static pushRecord(
    eventParams: Record<string, string> = {},
    eventCode: string = 'gzcmc.xhc.h5.onload',
    eventType: string = 'onload',
  ) {
    if (this.#isInit) {
      this.#startPush(eventParams, eventCode, eventType);
    } else {
      this.initYoumengLog(() => {
        this.#startPush(eventParams, eventCode, eventType);
      });
    }
  }

  /**
   * 增加友盟统计
   */
  static initYoumeng() {
    // eslint-disable-next-line no-var
    if (!YOUMENG_DOMAIN_LIST.includes(window.location.host)) return;
    var _czc: any = _czc || [];
    const src = `https://v1.cnzz.com/z.js?id=${YOUMENG_ID}&async=1`;
    this.#loadScript(src, 'youmeng');
  }
}

export default YouMeng;
